var bookshelf = require("../index-extended");
require("./BuildingOwner");
require("./Building");
require("./BuildingOwnerBuildingLot");

module.exports = bookshelf.model("BuildingLot", {
  entityName: "BuildingLot",
  entityTimestampable: true,
  entitySync: true,
  entityUuid: true,

  tableName: "building_lot",
  building_owners() {
    return this.belongsToMany(
      "BuildingOwner",
      "building_owner_building_lot",
      "building_lot_id",
      "building_owner_id"
    );
  },
  building() {
    return this.belongsTo("Building");
  },
  // HACK: get join table items
  building_owner_building_lots() {
    return this.hasMany("BuildingOwnerBuildingLot", "building_lot_id");
  },

  format(attrs) {
    delete attrs["$id"];
    delete attrs["building_owner_building_lots"];

    return attrs;
  },
});
